import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can `}<a parentName="p" {...{
        "href": "/cli-documentation/install"
      }}>{`install`}</a>{` a package locally if you want to depend on the package from your own module, using something like Node.js `}<inlineCode parentName="p">{`require`}</inlineCode>{`. This is `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`'s default behavior.`}</p>
    <h2>{`Installing an unscoped package`}</h2>
    <p>{`Unscoped packages are always public, which means they can be searched for, downloaded, and installed by anyone. To install a public package, on the command line, run`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install <package_name>
`}</code></pre>
    <p>{`This will create the `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` directory in your current directory (if one doesn't exist yet) and will download the package to that directory.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` If there is no `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file in the local directory, the latest version of the package is installed.`}</p>
      <p>{`If there is a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, npm installs the latest version that satisfies the `}<a parentName="p" {...{
          "href": "about-semantic-versioning"
        }}>{`semver rule`}</a>{` declared in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    </Note>
    <h2>{`Installed a scoped public package`}</h2>
    <p><a parentName="p" {...{
        "href": "about-scopes"
      }}>{`Scoped public packages`}</a>{` can be downloaded and installed by anyone, as long as the scope name is referenced during installation:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install @scope/package-name
`}</code></pre>
    <h2>{`Installing a private package`}</h2>
    <p><a parentName="p" {...{
        "href": "about-private-packages"
      }}>{`Private packages`}</a>{` can only be downloaded and installed by those who have been granted read access to the package. Since private packages are always scoped, you must reference the scope name during installation:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install @scope/private-package-name
`}</code></pre>
    <h2>{`Testing package installation`}</h2>
    <p>{`To confirm that `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` worked correctly, in your module directory, check that a `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` directory exists and that it contains a directory for the package(s) you installed:`}</p>
    <pre><code parentName="pre" {...{}}>{`ls node_modules
`}</code></pre>
    <h2>{`Installed package version`}</h2>
    <p>{`If there is a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file in the directory in which `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` is run, npm installs the latest version of the package that satisfies the `}<a parentName="p" {...{
        "href": "about-semantic-versioning"
      }}>{`semantic versioning rule`}</a>{` declared in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`If there is no `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, the latest version of the package is installed.`}</p>
    <h2>{`Installing a package with dist-tags`}</h2>
    <p>{`Like `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm install <package_name>`}</inlineCode>{` will use the `}<inlineCode parentName="p">{`latest`}</inlineCode>{` tag by default.`}</p>
    <p>{`To override this behavior, use `}<inlineCode parentName="p">{`npm install <package_name>@<tag>`}</inlineCode>{`. For example, to install the `}<inlineCode parentName="p">{`example-package`}</inlineCode>{` at the version tagged with `}<inlineCode parentName="p">{`beta`}</inlineCode>{`, you would run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install example-package@beta
`}</code></pre>
    <h2>{`Resources`}</h2>
    <iframe src="https://www.youtube.com/embed/JDSfqFFbNYQ" frameBorder="0" allowFullScreen></iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      